import { getActivePinia, storeToRefs, } from 'pinia'
import { useTopicListStore, } from '@/assets/js/src/modules/topic/_pinia/topicList'
import { ERROR, usePrefetchData, } from '@/assets/js/src/util/composables/usePrefetchData'
import { computed, } from 'vue'

export function useTopicListApi () {
    let activePinia = getActivePinia()
    let topicListStore = useTopicListStore(activePinia)
    let { topics, } = storeToRefs(topicListStore)

    let { messagesLoaded,allAsyncLoaded,asyncStatus, } = usePrefetchData({
        actions: [
            {
                item: topics,
                action: topicListStore.getTopics,
                payload: { page: 1, },
            },
        ],
        loadAsyncMessages: [ 'topic', 'common', ],
    })

    const asyncStatusError = computed(()=>asyncStatus.value === ERROR)

    return {
        topics,
        messagesLoaded,
        allAsyncLoaded,
        asyncStatusError,
    }
}
